import React from 'react';
import {
  CrossButton,
  EmptyBox,
  EmptyBoxContainer,
  EmptyImageBox,
  FreeStrip,
  PlusIcon,
} from '../SelectDiaperButton/styled';
import { useIsDesktop } from '../../../Utils/productPageUtils';

function DaiperPageBottomVarientLive(props) {
  const {
    items,
    addRemoveItemsHandler,
    clickAnimationHandler,
    isForNewCdPage,
  } = props;
  const isDesktop = useIsDesktop();
  return (
    <EmptyBoxContainer>
      {items?.[0]?.image ? (
        <>
          <EmptyBox image={items?.[0]?.image}>
            <EmptyImageBox src={items?.[0]?.image} alt="firstImage" />
            <CrossButton onClick={() => addRemoveItemsHandler(items?.[0]?.id)}>
              x
            </CrossButton>
          </EmptyBox>

          {!items?.[1]?.image ? <PlusIcon>+</PlusIcon> : null}
        </>
      ) : (
        <>
          <EmptyBox
            onClick={() => {
              clickAnimationHandler(false);
            }}
          >
            {1}
            <sup>st</sup>
          </EmptyBox>
          <PlusIcon>+</PlusIcon>
        </>
      )}
      {items?.[1]?.image ? (
        <>
          <EmptyBox image={items?.[1]?.image}>
            <EmptyImageBox src={items?.[1]?.image} alt="secondImage" />
            <CrossButton onClick={() => addRemoveItemsHandler(items?.[1]?.id)}>
              x
            </CrossButton>
          </EmptyBox>
          {!items?.[2]?.image ? <PlusIcon>+</PlusIcon> : null}
        </>
      ) : (
        <>
          <EmptyBox
            onClick={() => {
              clickAnimationHandler(false);
            }}
          >
            {2}
            <sup>nd</sup>
          </EmptyBox>
          <PlusIcon>+</PlusIcon>
        </>
      )}
      {items?.[2]?.image ? (
        <>
          <EmptyBox image={items?.[2]?.image}>
            <EmptyImageBox src={items?.[2]?.image} alt="secondImage" />
            <FreeStrip isForNewCdPage={isForNewCdPage}>FREE!!</FreeStrip>
            <CrossButton onClick={() => addRemoveItemsHandler(items?.[2]?.id)}>
              x
            </CrossButton>
          </EmptyBox>
        </>
      ) : (
        <EmptyBox
          onClick={() => {
            clickAnimationHandler(isForNewCdPage);
          }}
          free
        >
          FREE
        </EmptyBox>
      )}
    </EmptyBoxContainer>
  );
}

export default DaiperPageBottomVarientLive;
